
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiReorderHorizontalGoogle as ObiReorderHorizontalGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-reorder-horizontal-google.js';
 
 
 

 
 export const ObiReorderHorizontalGoogle = createComponent({
   react: React,
   tagName: 'obi-reorder-horizontal-google',
   elementClass: ObiReorderHorizontalGoogleElement,
   events: {
     
   }
  });
 
 